import React from 'react';
import { EntryType } from '@jbhi-fi/apis/src/contentful/types';

export const MAX_DESCRIPTION_WORDS = 500;

export type StackSchemaProps = {
  entryType: EntryType;
  heading: string;
  headline: string;
  description: string;
  datePublished: string;
  thumbnailUrl?: string;
  thumbnailWidth?: string;
  thumbnailHeight?: string;
  parentPage: string;
  authorName?: string;
  authorTitle?: string;
  authorImage?: string;
};

export const StackSchema = ({
  entryType,
  heading,
  headline,
  description,
  datePublished,
  thumbnailUrl,
  thumbnailWidth,
  thumbnailHeight,
  parentPage,
  authorName,
  authorTitle,
  authorImage,
}: StackSchemaProps) => {
  const url = window.location.href;
  const baseFields: any = {
    '@context': 'https://schema.org',
    '@type': entryType,
    name: heading,
    headline,
    datePublished: new Date(datePublished),
    url,
    thumbnailUrl,
    articleSection: parentPage,
    mainEntityOfPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': url,
    },
    publisher: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'JB Hi-Fi',
      url: window.location.origin,
      logo: {
        '@context': 'https://schema.org',
        '@type': 'ImageObject',
        url: 'https://cdn.shopify.com/s/files/1/0024/9803/5810/files/jbhifilogobannerjpg-1537244611298.jpg?v=1665980855',
        caption: 'JB Hi-Fi Logo',
      },
    },
    articleBody: {
      '@context': 'https://schema.org',
      '@type': 'text',
      description: description ? description.split(' ').slice(0, MAX_DESCRIPTION_WORDS).join(' ') : '',
    },
  };

  if (thumbnailUrl) {
    baseFields.image = {
      '@context': 'https://schema.org',
      '@type': 'ImageObject',
      url: thumbnailUrl,
      caption: heading,
      height: thumbnailHeight,
      width: thumbnailWidth,
    };
  }

  const extraFields = {
    author: {
      '@type': 'Person',
      name: authorName,
      jobTitle: authorTitle,
      image: {
        '@type': 'ImageObject',
        url: authorImage,
        caption: authorName,
      },
    },
  };

  const SCHEMA = JSON.stringify({
    ...baseFields,
    ...(entryType === EntryType.article ? extraFields : {}),
  });
  return <script type="application/ld+json">{SCHEMA}</script>;
};
